module.exports = __webpack_public_path__ + "static/img/red_cs.e84251b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/red_cs.jpg
// module id = 228
// module chunks = 40